import React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";

import logo from "../../images/logo/logo_mjb.png";
import { VERSION_APP } from "../../App";

const LogoWithVersion = ({ onLogoClick }) => (
	<div style={{ position: "relative", display: "inline-flex" }}>
		<img
			src={logo}
			alt="MyJouleBox logo"
			onClick={onLogoClick}
			style={{ cursor: onLogoClick ? "pointer" : "default" }}
		/>
		<Typography
			component="span"
			variant="caption"
			style={{
				position: "absolute",
				left: 0,
				bottom: -16,
				fontSize: "0.65rem",
				color: "#000",
				fontWeight: 600,
				letterSpacing: 0.5,
				textTransform: "uppercase"
			}}
		>
			{VERSION_APP}
		</Typography>
	</div>
);

LogoWithVersion.propTypes = {
	onLogoClick: PropTypes.func
};

export default LogoWithVersion;

